import React from "react";
import { DisplayProductsType } from "../components/DisplayProductType";

export function Cases(): JSX.Element {
    return <div>{DisplayProductsType("Case")}</div>;
}

export default Cases;
